<template>
  <svg
    :class="['icon', size]"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 37.2 43.49"
    @click="$emit('click', $event)"
  >
    <path
      class="cls-1"
      d="M18.6,26.98c-.88,0-1.6.72-1.6,1.6v4.85c0,.88.72,1.6,1.6,1.6s1.6-.72,1.6-1.6v-4.85c0-.88-.72-1.6-1.6-1.6Z"
    />
    <path
      class="cls-1"
      d="M31.74,15.57h-3.75v-7.05c0-4.69-3.82-8.51-8.51-8.51h-1.74c-4.69,0-8.51,3.82-8.51,8.51v7.05h-3.75c-3.02,0-5.47,2.45-5.47,5.47v16.99c0,3.02,2.45,5.47,5.47,5.47h26.27c3.02,0,5.47-2.45,5.47-5.47v-16.99c0-3.02-2.45-5.47-5.47-5.47ZM12.42,8.51c0-2.93,2.38-5.31,5.31-5.31h1.74c2.93,0,5.31,2.38,5.31,5.31v7.05h-12.37v-7.05ZM34,38.02c0,1.25-1.02,2.27-2.27,2.27H5.47c-1.25,0-2.27-1.02-2.27-2.27v-16.99c0-1.25,1.02-2.27,2.27-2.27h26.27c1.25,0,2.27,1.02,2.27,2.27v16.99Z"
    />
  </svg>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'IcKey',
  props: {
    size: {
      type: String,
      default: 'size'
    }
  },
  emits: ['click']
})
</script>

<style lang="scss" scoped>
.icon {
  fill: currentColor;
  stroke-width: 0;
  cursor: pointer;
}
.size {
  width: 1em;
  height: 1em;
}
.lg {
  width: 1.25em;
  height: 1.25em;
}
.sm {
  width: 0.85em;
  height: 0.85em;
}
</style>
